// flow weak

import React, {
    PureComponent
  }                         from 'react';
  import PropTypes          from 'prop-types';
  import {
      defaultOptions,
      checkStatus,
      parseJSON,
      getLocationOrigin
    }                     from '../../../services/fetchTools';
  import {
    AnimatedView,
    StatsTable,StatsGraph, ScoreCard,GameTypeTab
  }                         from '../../../components';
  import Card from '../../../components/card/Card'
  import styled from 'styled-components'
  import TicketStatus from '../crud/ticketStatus'
  import CallStatus from '../crud/callStatus'
  import ResponseLeads from '../responseLeads'
  import Rental from '../crud/rental'
  import CheckInOut from '../crud/checkInOut'
  import SessionDetails from '../crud/viewFixtureSession'
  import PartnerTasks from '../PartnerTasks'
  import CriticalTimeSlot from '../crud/CriticalTimeSlot'
  import CriticalBatches from '../crud/CriticalBatches'
  import UnconfirmedAllocations from '../crud/UnconfirmedAllocations'
  import VenueRent from '../crud/venueRent'
  import BuddySalary from '../crud/buddySalary'
  import Expenses from '../../centerportal/crud/expenses'
  
  
  class PartnerExpense extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
        super(props);
        this.state = {
            rent:false,
            local:false,
            salary:true,
            prev_month_rent:0,
            prev_month_salary:0,
            prev_month_local_expense:0
        };
        this.onRentClick = this.onRentClick.bind(this);
        this.onLocalClick = this.onLocalClick.bind(this);
        this.onSalaryClick = this.onSalaryClick.bind(this);
      }
  
    componentWillMount() {
      const { actions: { enterPage } } = this.props;
      enterPage('PartnerWorkBench');
    }

    onRentClick(){
        console.log('onRentClick')
        this.setState({rent:true,local:false,salary:false})
    }

    onLocalClick(){
        this.setState({rent:false,local:true,salary:false})
    }

    onSalaryClick(){
        this.setState({rent:false,local:false,salary:true})
    }
  
    componentDidMount() {
      this.getDetails();
      // this.getIncompletsessionCount();
      const {
        actions: {
          fetchStatsTableDataIfNeeded,
          fetchScoreCardDataIfNeeded
        }
      } = this.props;
  
    }
  
    componentWillUnmount() {
      const { actions: { leavePage } } = this.props;
      leavePage('PartnerWorkBench');
    }

    getDetails(){
      const url = `${getLocationOrigin()}/cm/get_total_expense`;
      const options = {...defaultOptions};
      console.log('get details')

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
             this.setState({prev_month_rent: data.prev_month_rent,prev_month_salary:data.prev_month_salary,prev_month_local_expense:data.prev_month_local_expense});
             // alert("fix");
         }).catch(error => error);
    }
    
  
    render() {
      console.log(this.state)
      console.log('card')

      console.log(this.state.missed_calls)
      console.log(this.state.open_tickets)
      // console.log(Card)
      const {
        statsTable,
        scoreCard
      } = this.props;
  
      const {
        actions: {
          fetchStatsTableDataIfNeeded,
          fetchScoreCardDataIfNeeded,
        }
      } = this.props;

      const salry_style = '#4daa0b'
  
      const StyledRoot = styled.div`
      padding: 0px;
      display: flex;
      flex-direction: row;
      
      `
      const StyledContainer = styled.div`
        width: 100%;
        
        `
        const Title = styled.h4`
        padding-top: 20px;
        background: white;
        color: black;
        font-weight: 300;
        text-align: center;
        width:100%;
        height:50px;
        margin:auto;
        @media (max-width: 500px) {
            font-size: 1rem;
        }
        `
      console.log(this.state)
      
  
  
  
      return(
      <div>
        <StyledRoot className='col-md-12'>
        <StyledContainer className='col-md-4'>
            <Card
              title="Salary"
              count={this.state.prev_month_salary ? this.state.prev_month_salary : '-'}
              style = {salry_style}
              action={"Close Them"}
              onClick={this.onSalaryClick}
            />
          </StyledContainer>
  
          <StyledContainer className='col-md-4'>
            <Card
              title="Rent"
              count={this.state.prev_month_rent ? this.state.prev_month_rent : '-'}
              style = {salry_style}
              action={"Call Back"}
              onClick={this.onRentClick}
            />
          </StyledContainer>
  
          <StyledContainer className='col-md-4'>
            <Card
              title="Local Expense"
              count={this.state.prev_month_local_expense ? this.state.prev_month_local_expense : '-'}
              style = {salry_style}
              action={"Contact"}
              onClick={this.onLocalClick}
            />
          </StyledContainer>

          <StyledContainer className='col-md-4'>
            <Card
              title="Marketing Expense"
              count="-"
              style = {salry_style}
              action={"Contact"}
              onClick={this.onRentClick}
            />
          </StyledContainer>
        </StyledRoot>
        
        {this.state.salary &&
            <BuddySalary />    
        }

        {this.state.rent &&
            <VenueRent />}

        {this.state.local &&
            <Expenses from_partner_tab={true} />
            }
      </div>
      );
    }
  }
  
  export default PartnerExpense;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/partnerExpense/partnerExpense.js